import e, { useRef as t, useState as n, useEffect as r } from "react";
function o(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function a(e, t, n, r, o, a, i) {
  try {
    var l = e[a](i),
      c = l.value;
  } catch (e) {
    return void n(e);
  }
  l.done ? t(c) : Promise.resolve(c).then(r, o);
}
function i() {
  i = function i() {
    return t;
  };
  var e,
    t = {},
    n = Object.prototype,
    r = n.hasOwnProperty,
    o = Object.defineProperty || function (e, t, n) {
      e[t] = n.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    l = a.iterator || "@@iterator",
    c = a.asyncIterator || "@@asyncIterator",
    s = a.toStringTag || "@@toStringTag";
  function u(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    u({}, "");
  } catch (e) {
    u = function u(e, t, n) {
      return e[t] = n;
    };
  }
  function d(e, t, n, r) {
    var a = t && t.prototype instanceof v ? t : v,
      i = Object.create(a.prototype),
      l = new C(r || []);
    return o(i, "_invoke", {
      value: S(e, n, l)
    }), i;
  }
  function f(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = d;
  var p = "suspendedStart",
    y = "suspendedYield",
    m = "executing",
    h = "completed",
    _ = {};
  function v() {}
  function g() {}
  function b() {}
  var w = {};
  u(w, l, function () {
    return this;
  });
  var x = Object.getPrototypeOf,
    E = x && x(x(N([])));
  E && E !== n && r.call(E, l) && (w = E);
  var P = b.prototype = v.prototype = Object.create(w);
  function k(e) {
    ["next", "throw", "return"].forEach(function (t) {
      u(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function R(e, t) {
    function n(o, a, i, l) {
      var c = f(e[o], e, a);
      if ("throw" !== c.type) {
        var s = c.arg,
          u = s.value;
        return u && "object" == typeof u && r.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
          n("next", e, i, l);
        }, function (e) {
          n("throw", e, i, l);
        }) : t.resolve(u).then(function (e) {
          s.value = e, i(s);
        }, function (e) {
          return n("throw", e, i, l);
        });
      }
      l(c.arg);
    }
    var a;
    o(this, "_invoke", {
      value: function value(e, r) {
        function o() {
          return new t(function (t, o) {
            n(e, r, t, o);
          });
        }
        return a = a ? a.then(o, o) : o();
      }
    });
  }
  function S(t, n, r) {
    var o = p;
    return function (a, i) {
      if (o === m) throw Error("Generator is already running");
      if (o === h) {
        if ("throw" === a) throw i;
        return {
          value: e,
          done: !0
        };
      }
      for (r.method = a, r.arg = i;;) {
        var l = r.delegate;
        if (l) {
          var c = j(l, r);
          if (c) {
            if (c === _) continue;
            return c;
          }
        }
        if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
          if (o === p) throw o = h, r.arg;
          r.dispatchException(r.arg);
        } else "return" === r.method && r.abrupt("return", r.arg);
        o = m;
        var s = f(t, n, r);
        if ("normal" === s.type) {
          if (o = r.done ? h : y, s.arg === _) continue;
          return {
            value: s.arg,
            done: r.done
          };
        }
        "throw" === s.type && (o = h, r.method = "throw", r.arg = s.arg);
      }
    };
  }
  function j(t, n) {
    var r = n.method,
      o = t.iterator[r];
    if (o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, j(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), _;
    var a = f(o, t.iterator, n.arg);
    if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, _;
    var i = a.arg;
    return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, _) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, _);
  }
  function O(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function L(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function C(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(O, this), this.reset(!0);
  }
  function N(t) {
    if (t || "" === t) {
      var n = t[l];
      if (n) return n.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var o = -1,
          a = function n() {
            for (; ++o < t.length;) if (r.call(t, o)) return n.value = t[o], n.done = !1, n;
            return n.value = e, n.done = !0, n;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof t + " is not iterable");
  }
  return g.prototype = b, o(P, "constructor", {
    value: b,
    configurable: !0
  }), o(b, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = u(b, s, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, u(e, s, "GeneratorFunction")), e.prototype = Object.create(P), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, k(R.prototype), u(R.prototype, c, function () {
    return this;
  }), t.AsyncIterator = R, t.async = function (e, n, r, o, a) {
    void 0 === a && (a = Promise);
    var i = new R(d(e, n, r, o), a);
    return t.isGeneratorFunction(n) ? i : i.next().then(function (e) {
      return e.done ? e.value : i.next();
    });
  }, k(P), u(P, s, "Generator"), u(P, l, function () {
    return this;
  }), u(P, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      n = [];
    for (var r in t) n.push(r);
    return n.reverse(), function e() {
      for (; n.length;) {
        var r = n.pop();
        if (r in t) return e.value = r, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = N, C.prototype = {
    constructor: C,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !t) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var n = this;
      function o(r, o) {
        return l.type = "throw", l.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var i = this.tryEntries[a],
          l = i.completion;
        if ("root" === i.tryLoc) return o("end");
        if (i.tryLoc <= this.prev) {
          var c = r.call(i, "catchLoc"),
            s = r.call(i, "finallyLoc");
          if (c && s) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
          } else {
            if (!s) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var o = this.tryEntries[n];
        if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var a = o;
          break;
        }
      }
      a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
      var i = a ? a.completion : {};
      return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, _) : this.complete(i);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), _;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), L(n), _;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var r = n.completion;
          if ("throw" === r.type) {
            var o = r.arg;
            L(n);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, n, r) {
      return this.delegate = {
        iterator: N(t),
        resultName: n,
        nextLoc: r
      }, "next" === this.method && (this.arg = e), _;
    }
  }, t;
}
function l(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        a,
        i,
        l = [],
        c = !0,
        s = !1;
      try {
        if (a = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          c = !1;
        } else for (; !(c = (r = a.call(n)).done) && (l.push(r.value), l.length !== t); c = !0);
      } catch (e) {
        s = !0, o = e;
      } finally {
        try {
          if (!c && null != n.return && (i = n.return(), Object(i) !== i)) return;
        } finally {
          if (s) throw o;
        }
      }
      return l;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return o(e, t);
      var n = {}.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function c(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var s,
  u = {
    exports: {}
  },
  d = {
    exports: {}
  },
  f = {};
var p,
  y,
  m,
  h,
  _,
  v,
  g,
  b,
  w,
  x,
  E,
  P,
  k,
  R,
  S = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function j() {
  return y || (y = 1, "production" === process.env.NODE_ENV ? d.exports = function () {
    if (s) return f;
    s = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      c = e ? Symbol.for("react.async_mode") : 60111,
      u = e ? Symbol.for("react.concurrent_mode") : 60111,
      d = e ? Symbol.for("react.forward_ref") : 60112,
      p = e ? Symbol.for("react.suspense") : 60113,
      y = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      h = e ? Symbol.for("react.lazy") : 60116,
      _ = e ? Symbol.for("react.block") : 60121,
      v = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function w(e) {
      if ("object" == typeof e && null !== e) {
        var s = e.$$typeof;
        switch (s) {
          case t:
            switch (e = e.type) {
              case c:
              case u:
              case r:
              case a:
              case o:
              case p:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case d:
                  case h:
                  case m:
                  case i:
                    return e;
                  default:
                    return s;
                }
            }
          case n:
            return s;
        }
      }
    }
    function x(e) {
      return w(e) === u;
    }
    return f.AsyncMode = c, f.ConcurrentMode = u, f.ContextConsumer = l, f.ContextProvider = i, f.Element = t, f.ForwardRef = d, f.Fragment = r, f.Lazy = h, f.Memo = m, f.Portal = n, f.Profiler = a, f.StrictMode = o, f.Suspense = p, f.isAsyncMode = function (e) {
      return x(e) || w(e) === c;
    }, f.isConcurrentMode = x, f.isContextConsumer = function (e) {
      return w(e) === l;
    }, f.isContextProvider = function (e) {
      return w(e) === i;
    }, f.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, f.isForwardRef = function (e) {
      return w(e) === d;
    }, f.isFragment = function (e) {
      return w(e) === r;
    }, f.isLazy = function (e) {
      return w(e) === h;
    }, f.isMemo = function (e) {
      return w(e) === m;
    }, f.isPortal = function (e) {
      return w(e) === n;
    }, f.isProfiler = function (e) {
      return w(e) === a;
    }, f.isStrictMode = function (e) {
      return w(e) === o;
    }, f.isSuspense = function (e) {
      return w(e) === p;
    }, f.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === u || e === a || e === o || e === p || e === y || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === i || e.$$typeof === l || e.$$typeof === d || e.$$typeof === v || e.$$typeof === g || e.$$typeof === b || e.$$typeof === _);
    }, f.typeOf = w, f;
  }() : d.exports = (p || (p = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      c = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      f = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      y = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      _ = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function g(e) {
      if ("object" == typeof e && null !== e) {
        var f = e.$$typeof;
        switch (f) {
          case t:
            var m = e.type;
            switch (m) {
              case c:
              case s:
              case r:
              case a:
              case o:
              case d:
                return m;
              default:
                var h = m && m.$$typeof;
                switch (h) {
                  case l:
                  case u:
                  case y:
                  case p:
                  case i:
                    return h;
                  default:
                    return f;
                }
            }
          case n:
            return f;
        }
      }
    }
    var b = c,
      w = s,
      x = l,
      E = i,
      P = t,
      k = u,
      R = r,
      j = y,
      O = p,
      L = n,
      C = a,
      N = o,
      T = d,
      $ = !1;
    function M(e) {
      return g(e) === s;
    }
    S.AsyncMode = b, S.ConcurrentMode = w, S.ContextConsumer = x, S.ContextProvider = E, S.Element = P, S.ForwardRef = k, S.Fragment = R, S.Lazy = j, S.Memo = O, S.Portal = L, S.Profiler = C, S.StrictMode = N, S.Suspense = T, S.isAsyncMode = function (e) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(e) || g(e) === c;
    }, S.isConcurrentMode = M, S.isContextConsumer = function (e) {
      return g(e) === l;
    }, S.isContextProvider = function (e) {
      return g(e) === i;
    }, S.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, S.isForwardRef = function (e) {
      return g(e) === u;
    }, S.isFragment = function (e) {
      return g(e) === r;
    }, S.isLazy = function (e) {
      return g(e) === y;
    }, S.isMemo = function (e) {
      return g(e) === p;
    }, S.isPortal = function (e) {
      return g(e) === n;
    }, S.isProfiler = function (e) {
      return g(e) === a;
    }, S.isStrictMode = function (e) {
      return g(e) === o;
    }, S.isSuspense = function (e) {
      return g(e) === d;
    }, S.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === s || e === a || e === o || e === d || e === f || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === p || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === h || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === m);
    }, S.typeOf = g;
  }()), S)), d.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function O() {
  if (h) return m;
  h = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  return m = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (r, o) {
    for (var a, i, l = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(r), c = 1; c < arguments.length; c++) {
      for (var s in a = Object(arguments[c])) t.call(a, s) && (l[s] = a[s]);
      if (e) {
        i = e(a);
        for (var u = 0; u < i.length; u++) n.call(a, i[u]) && (l[i[u]] = a[i[u]]);
      }
    }
    return l;
  }, m;
}
function L() {
  if (v) return _;
  v = 1;
  return _ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function C() {
  return b ? g : (b = 1, g = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var N = j();
  u.exports = function () {
    if (P) return E;
    P = 1;
    var e = j(),
      t = O(),
      n = L(),
      r = C(),
      o = function () {
        if (x) return w;
        x = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var t = L(),
            n = {},
            r = C();
          e = function e(_e) {
            var t = "Warning: " + _e;
            "undefined" != typeof console && console.error(t);
            try {
              throw new Error(t);
            } catch (e) {}
          };
        }
        function o(o, a, i, l, c) {
          if ("production" !== process.env.NODE_ENV) for (var s in o) if (r(o, s)) {
            var u;
            try {
              if ("function" != typeof o[s]) {
                var d = Error((l || "React class") + ": " + i + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw d.name = "Invariant Violation", d;
              }
              u = o[s](a, s, l, i, null, t);
            } catch (e) {
              u = e;
            }
            if (!u || u instanceof Error || e((l || "React class") + ": type specification of " + i + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in n)) {
              n[u.message] = !0;
              var f = c ? c() : "";
              e("Failed " + i + " type: " + u.message + (null != f ? f : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (n = {});
        }, w = o;
      }(),
      a = function a() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }), E = function E(l, c) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        u = "<<anonymous>>",
        d = {
          array: m("array"),
          bigint: m("bigint"),
          bool: m("boolean"),
          func: m("function"),
          number: m("number"),
          object: m("object"),
          string: m("string"),
          symbol: m("symbol"),
          any: y(i),
          arrayOf: function arrayOf(e) {
            return y(function (t, r, o, a, i) {
              if ("function" != typeof e) return new p("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var l = t[r];
              if (!Array.isArray(l)) return new p("Invalid " + a + " `" + i + "` of type `" + v(l) + "` supplied to `" + o + "`, expected an array.");
              for (var c = 0; c < l.length; c++) {
                var s = e(l, c, o, a, i + "[" + c + "]", n);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: y(function (e, t, n, r, o) {
            var a = e[t];
            return l(a) ? null : new p("Invalid " + r + " `" + o + "` of type `" + v(a) + "` supplied to `" + n + "`, expected a single ReactElement.");
          }),
          elementType: y(function (t, n, r, o, a) {
            var i = t[n];
            return e.isValidElementType(i) ? null : new p("Invalid " + o + " `" + a + "` of type `" + v(i) + "` supplied to `" + r + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return y(function (t, n, r, o, a) {
              if (!(t[n] instanceof e)) {
                var i = e.name || u;
                return new p("Invalid " + o + " `" + a + "` of type `" + ((l = t[n]).constructor && l.constructor.name ? l.constructor.name : u) + "` supplied to `" + r + "`, expected instance of `" + i + "`.");
              }
              var l;
              return null;
            });
          },
          node: y(function (e, t, n, r, o) {
            return _(e[t]) ? null : new p("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return y(function (t, o, a, i, l) {
              if ("function" != typeof e) return new p("Property `" + l + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var c = t[o],
                s = v(c);
              if ("object" !== s) return new p("Invalid " + i + " `" + l + "` of type `" + s + "` supplied to `" + a + "`, expected an object.");
              for (var u in c) if (r(c, u)) {
                var d = e(c, u, a, i, l + "." + u, n);
                if (d instanceof Error) return d;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? y(function (t, n, r, o, a) {
              for (var i = t[n], l = 0; l < e.length; l++) if (f(i, e[l])) return null;
              var c = JSON.stringify(e, function (e, t) {
                return "symbol" === g(t) ? String(t) : t;
              });
              return new p("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + r + "`, expected one of " + c + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var t = 0; t < e.length; t++) {
              var o = e[t];
              if ("function" != typeof o) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + b(o) + " at index " + t + "."), i;
            }
            return y(function (t, o, a, i, l) {
              for (var c = [], s = 0; s < e.length; s++) {
                var u = (0, e[s])(t, o, a, i, l, n);
                if (null == u) return null;
                u.data && r(u.data, "expectedType") && c.push(u.data.expectedType);
              }
              return new p("Invalid " + i + " `" + l + "` supplied to `" + a + "`" + (c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return y(function (t, r, o, a, i) {
              var l = t[r],
                c = v(l);
              if ("object" !== c) return new p("Invalid " + a + " `" + i + "` of type `" + c + "` supplied to `" + o + "`, expected `object`.");
              for (var s in e) {
                var u = e[s];
                if ("function" != typeof u) return h(o, a, i, s, g(u));
                var d = u(l, s, o, a, i + "." + s, n);
                if (d) return d;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return y(function (o, a, i, l, c) {
              var s = o[a],
                u = v(s);
              if ("object" !== u) return new p("Invalid " + l + " `" + c + "` of type `" + u + "` supplied to `" + i + "`, expected `object`.");
              var d = t({}, o[a], e);
              for (var f in d) {
                var y = e[f];
                if (r(e, f) && "function" != typeof y) return h(i, l, c, f, g(y));
                if (!y) return new p("Invalid " + l + " `" + c + "` key `" + f + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var m = y(s, f, i, l, c + "." + f, n);
                if (m) return m;
              }
              return null;
            });
          }
        };
      function f(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function p(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }
      function y(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
          r = 0;
        function o(o, i, l, s, d, f, y) {
          if (s = s || u, f = f || l, y !== n) {
            if (c) {
              var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw m.name = "Invariant Violation", m;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var h = s + ":" + l;
              !t[h] && r < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[h] = !0, r++);
            }
          }
          return null == i[l] ? o ? null === i[l] ? new p("The " + d + " `" + f + "` is marked as required in `" + s + "`, but its value is `null`.") : new p("The " + d + " `" + f + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(i, l, s, d, f);
        }
        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }
      function m(e) {
        return y(function (t, n, r, o, a, i) {
          var l = t[n];
          return v(l) !== e ? new p("Invalid " + o + " `" + a + "` of type `" + g(l) + "` supplied to `" + r + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function h(e, t, n, r, o) {
        return new p((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function _(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(_);
            if (null === e || l(e)) return !0;
            var t = function (e) {
              var t = e && (s && e[s] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(e);
            if (!t) return !1;
            var n,
              r = t.call(e);
            if (t !== e.entries) {
              for (; !(n = r.next()).done;) if (!_(n.value)) return !1;
            } else for (; !(n = r.next()).done;) {
              var o = n.value;
              if (o && !_(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function v(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }
      function g(e) {
        if (null == e) return "" + e;
        var t = v(e);
        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return t;
      }
      function b(e) {
        var t = g(e);
        switch (t) {
          case "array":
          case "object":
            return "an " + t;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;
          default:
            return t;
        }
      }
      return p.prototype = Error.prototype, d.checkPropTypes = o, d.resetWarningCache = o.resetWarningCache, d.PropTypes = d, d;
    }, E;
  }()(N.isElement, !0);
} else u.exports = function () {
  if (R) return k;
  R = 1;
  var e = L();
  function t() {}
  function n() {}
  return n.resetWarningCache = t, k = function k() {
    function r(t, n, r, o, a, i) {
      if (i !== e) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }
    function o() {
      return r;
    }
    r.isRequired = r;
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  };
}()();
var T = c(u.exports),
  $ = {
    exports: {}
  },
  M = c($.exports = function () {
    var e = function e() {},
      t = {},
      n = {},
      r = {};
    function o(e, t) {
      e = e.push ? e : [e];
      var o,
        a,
        i,
        l = [],
        c = e.length,
        s = c;
      for (o = function o(e, n) {
        n.length && l.push(e), --s || t(l);
      }; c--;) a = e[c], (i = n[a]) ? o(a, i) : (r[a] = r[a] || []).push(o);
    }
    function a(e, t) {
      if (e) {
        var o = r[e];
        if (n[e] = t, o) for (; o.length;) o[0](e, t), o.splice(0, 1);
      }
    }
    function i(t, n) {
      t.call && (t = {
        success: t
      }), n.length ? (t.error || e)(n) : (t.success || e)(t);
    }
    function l(t, n, r, o) {
      var a,
        i,
        c,
        s = document,
        u = r.async,
        d = (r.numRetries || 0) + 1,
        f = r.before || e,
        p = t.replace(/[\?|#].*$/, ""),
        y = t.replace(/^(css|img|module|nomodule)!/, "");
      if (o = o || 0, /(^css!|\.css$)/.test(p)) (c = s.createElement("link")).rel = "stylesheet", c.href = y, (a = "hideFocus" in c) && c.relList && (a = 0, c.rel = "preload", c.as = "style");else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(p)) (c = s.createElement("img")).src = y;else if ((c = s.createElement("script")).src = y, c.async = void 0 === u || u, i = "noModule" in c, /^module!/.test(p)) {
        if (!i) return n(t, "l");
        c.type = "module";
      } else if (/^nomodule!/.test(p) && i) return n(t, "l");
      c.onload = c.onerror = c.onbeforeload = function (e) {
        var i = e.type[0];
        if (a) try {
          c.sheet.cssText.length || (i = "e");
        } catch (e) {
          18 != e.code && (i = "e");
        }
        if ("e" == i) {
          if ((o += 1) < d) return l(t, n, r, o);
        } else if ("preload" == c.rel && "style" == c.as) return c.rel = "stylesheet";
        n(t, i, e.defaultPrevented);
      }, !1 !== f(t, c) && s.head.appendChild(c);
    }
    function c(e, t, n) {
      var r,
        o,
        a = (e = e.push ? e : [e]).length,
        i = a,
        c = [];
      for (r = function r(e, n, _r) {
        if ("e" == n && c.push(e), "b" == n) {
          if (!_r) return;
          c.push(e);
        }
        --a || t(c);
      }, o = 0; o < i; o++) l(e[o], r, n);
    }
    function s(e, n, r) {
      var o, l;
      if (n && n.trim && (o = n), l = (o ? r : n) || {}, o) {
        if (o in t) throw "LoadJS";
        t[o] = !0;
      }
      function s(t, n) {
        c(e, function (e) {
          i(l, e), t && i({
            success: t,
            error: n
          }, e), a(o, e);
        }, l);
      }
      if (l.returnPromise) return new Promise(s);
      s();
    }
    return s.ready = function (e, t) {
      return o(e, function (e) {
        i(t, e);
      }), s;
    }, s.done = function (e) {
      a(e, []);
    }, s.reset = function () {
      t = {}, n = {}, r = {};
    }, s.isDefined = function (e) {
      return e in t;
    }, s;
  }());
var A = "RadioPlayer-module_media_player__backdrop__koc5o",
  I = "RadioPlayer-module_media_player__cont__G5fJq",
  V = "RadioPlayer-module_media_player_controls__cont__5FAgF",
  F = "RadioPlayer-module_show__kLAwZ",
  D = "RadioPlayer-module_hide__JplVd",
  G = "RadioPlayer-module_media_player_logo__cont__HG5J2",
  B = "RadioPlayer-module_media_player_logo__NfGmg",
  q = "RadioPlayer-module_on_air_text__cont__McSXl",
  z = "RadioPlayer-module_on_air_text__B-djv",
  J = "RadioPlayer-module_on_air_text_show__BflVB",
  Y = "RadioPlayer-module_loading__8-7UI",
  U = "RadioPlayer-module_play_control_button__svt-K",
  H = "RadioPlayer-module_loading_spinner__6tdcf",
  W = "RadioPlayer-module_play__R7a-l",
  X = "RadioPlayer-module_stop__tCiFW",
  K = "RadioPlayer-module_dismiss_button__Dpiff",
  Z = "RadioPlayer-module_volume_button__yGmSl";
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('@keyframes RadioPlayer-module_slideIn__Zzr99 {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n@keyframes RadioPlayer-module_rotate__BYfG4 {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes RadioPlayer-module_loadingDots__8BvM4 {\n  0% {\n    content: "";\n  }\n  25% {\n    content: ".";\n  }\n  50% {\n    content: "..";\n  }\n  75% {\n    content: "...";\n  }\n  100% {\n    content: "";\n  }\n}\n.RadioPlayer-module_media_player__backdrop__koc5o {\n  background: rgba(0, 0, 0, 0.75);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: calc(100% - 62px);\n  z-index: 999;\n}\n\n.RadioPlayer-module_media_player__cont__G5fJq {\n  width: 320px;\n  height: 180px;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_media_player__cont__G5fJq {\n    width: 640px;\n    height: 360px;\n  }\n}\n\n.RadioPlayer-module_media_player_controls__cont__5FAgF {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  background-color: #002b49;\n  height: 62px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  transform: translateY(0);\n  transition: transform 0.3s ease-in-out;\n}\n.RadioPlayer-module_media_player_controls__cont__5FAgF.RadioPlayer-module_show__kLAwZ {\n  animation: RadioPlayer-module_slideIn__Zzr99 0.3s ease-in-out;\n  transform: translateY(0);\n}\n.RadioPlayer-module_media_player_controls__cont__5FAgF.RadioPlayer-module_hide__JplVd {\n  transform: translateY(100%);\n}\n\n.RadioPlayer-module_media_player_logo__cont__HG5J2 {\n  width: 64px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #005eb8;\n  border-radius: 0px 0px 8px 0px;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_media_player_logo__cont__HG5J2 {\n    width: 194px;\n    justify-content: flex-end;\n    padding-right: 16px;\n  }\n}\n.RadioPlayer-module_media_player_logo__cont__HG5J2 .RadioPlayer-module_media_player_logo__NfGmg {\n  width: 50px;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_media_player_logo__cont__HG5J2 .RadioPlayer-module_media_player_logo__NfGmg {\n    width: 76px;\n  }\n}\n\n.RadioPlayer-module_on_air_text__cont__McSXl {\n  flex: 1;\n  position: relative;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_on_air_text__cont__McSXl {\n    max-width: 450px;\n    white-space: nowrap;\n  }\n}\n.RadioPlayer-module_on_air_text__cont__McSXl .RadioPlayer-module_on_air_text__B-djv {\n  font-family: "protipo-narrow";\n  font-size: 15px;\n  color: #5bc2e7;\n  font-style: italic;\n  font-weight: 500;\n  margin: 10px 16px 10px 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2em;\n  max-height: 2.4em;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_on_air_text__cont__McSXl .RadioPlayer-module_on_air_text__B-djv {\n    display: flex;\n    margin: 16px 16px 16px 16px;\n  }\n}\n.RadioPlayer-module_on_air_text__cont__McSXl .RadioPlayer-module_on_air_text__B-djv .RadioPlayer-module_on_air_text_show__BflVB {\n  color: #ffffff;\n  margin-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.RadioPlayer-module_on_air_text__cont__McSXl .RadioPlayer-module_on_air_text__B-djv .RadioPlayer-module_on_air_text_show__BflVB.RadioPlayer-module_loading__8-7UI::after {\n  display: inline-block;\n  animation: RadioPlayer-module_loadingDots__8BvM4 steps(1, end) 1.5s infinite;\n  content: "";\n}\n.RadioPlayer-module_on_air_text__cont__McSXl::before {\n  content: " ";\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  top: 16px;\n  left: 6px;\n  background: #da291c;\n  border-radius: 50%;\n}\n@media (min-width: 768px) {\n  .RadioPlayer-module_on_air_text__cont__McSXl::before {\n    top: 22px;\n    left: 6px;\n  }\n}\n\n.RadioPlayer-module_play_control_button__svt-K {\n  align-self: center;\n  justify-self: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 8px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background-color: #005eb8;\n  padding: 0;\n}\n.RadioPlayer-module_play_control_button__svt-K:hover {\n  border: 4px solid #53bbe1;\n  cursor: pointer;\n}\n.RadioPlayer-module_play_control_button__svt-K .RadioPlayer-module_loading_spinner__6tdcf {\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border-top: 4px solid #53bbe1;\n  border-right: 4px solid #53bbe1;\n  border-bottom: 4px solid #53bbe1;\n  border-left: 4px solid #005eb8;\n  animation: RadioPlayer-module_rotate__BYfG4 1s linear infinite;\n}\n.RadioPlayer-module_play_control_button__svt-K .RadioPlayer-module_play__R7a-l {\n  margin-left: 4px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 10.5px 0 10.5px 17px;\n  border-color: transparent transparent transparent #ffffff;\n}\n.RadioPlayer-module_play_control_button__svt-K .RadioPlayer-module_stop__tCiFW {\n  width: 18px;\n  height: 18px;\n  position: absolute;\n  background-color: #53bbe1;\n}\n\n.RadioPlayer-module_dismiss_button__Dpiff {\n  flex-basis: 36px;\n  align-self: center;\n  width: 14px;\n  height: 14px;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n}\n.RadioPlayer-module_dismiss_button__Dpiff:hover {\n  cursor: pointer;\n  opacity: 0.5;\n}\n.RadioPlayer-module_dismiss_button__Dpiff img {\n  vertical-align: top !important;\n}\n\n.RadioPlayer-module_volume_button__yGmSl {\n  background-color: transparent;\n  border: none;\n  width: 24px;\n  height: 24px;\n  flex-basis: 40px;\n  align-self: center;\n  padding: 0;\n}\n.RadioPlayer-module_volume_button__yGmSl:hover {\n  cursor: pointer;\n}\n.RadioPlayer-module_volume_button__yGmSl img {\n  vertical-align: top !important;\n}');
var Q = function Q(o) {
  var c = o.isMute,
    s = o.hidePlayer,
    u = o.dismissable,
    d = o.onDismiss,
    f = o.autoplay,
    p = o.adpath,
    y = o.callLetter,
    m = o.streamUrl,
    h = o.enableAds,
    _ = o.stationLogo,
    v = o.stationName,
    g = o.currentShowName,
    b = o.currentShowTime,
    w = t(null),
    x = l(n(!1), 2),
    E = x[0],
    P = x[1],
    k = l(n(!1), 2),
    R = k[0],
    S = k[1],
    j = l(n(!1), 2),
    O = j[0],
    L = j[1],
    C = l(n(!s), 2),
    N = C[0],
    T = C[1],
    $ = l(n(c), 2),
    Q = $[0],
    ee = $[1],
    te = Q ? "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M20.5219 7.22815C21.1494 7.85428 21.6473 8.59805 21.9871 9.41688C22.3268 10.2357 22.5017 11.1135 22.5017 12C22.5017 12.8865 22.3268 13.7643 21.9871 14.5832C21.6473 15.402 21.1494 16.1458 20.5219 16.7719' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M7.5 8.25V15.75' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M17.8688 9.88123C18.1477 10.1591 18.369 10.4893 18.52 10.8529C18.671 11.2164 18.7488 11.6063 18.7488 12C18.7488 12.3937 18.671 12.7835 18.52 13.1471C18.369 13.5107 18.1477 13.8409 17.8688 14.1187' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M4.5 3.75L19.5 20.25' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M14.25 14.475V21L7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V8.99999C2.25 8.80108 2.32902 8.61031 2.46967 8.46966C2.61032 8.32901 2.80109 8.24999 3 8.24999H7.5L8.1375 7.75311' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M10.5188 5.90625L14.25 3V10.0125' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e" : "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M20.5219 7.22815C21.1494 7.85428 21.6473 8.59805 21.9871 9.41688C22.3268 10.2357 22.5017 11.1135 22.5017 12C22.5017 12.8865 22.3268 13.7643 21.9871 14.5832C21.6473 15.402 21.1494 16.1458 20.5219 16.7719' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M7.5 8.25V15.75' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M17.8688 9.88123C18.1477 10.1591 18.369 10.4893 18.52 10.8529C18.671 11.2164 18.7488 11.6063 18.7488 12C18.7488 12.3937 18.671 12.7835 18.52 13.1471C18.369 13.5107 18.1477 13.8409 17.8688 14.1187' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";
  r(function () {
    T(!s);
  }, [s]), r(function () {
    ee(c);
  }, [c]), r(function () {
    var e = {
      autoplay: f,
      paths: {
        plugins: "https://www.sportsnet.ca/amp_2.123.14/akamai/amp/",
        player: "https://www.sportsnet.ca/amp_2.123.14/amp.premier/",
        resources: "https://www.sportsnet.ca/amp_2.123.14/resources/"
      },
      ima: {
        resources: [{
          type: "text/javascript",
          src: "//imasdk.googleapis.com/js/sdkloader/ima3.js",
          debug: "//imasdk.googleapis.com/js/sdkloader/ima3_debug.js"
        }],
        enabled: h,
        version: 3,
        adTagUrl: {
          params: {
            sz: "640x360",
            iu: "/7326/".concat(p, "/listenLive"),
            ciu_szs: "300x250,300x60",
            ad_rule: 1,
            impl: "s",
            gdfp_req: 1,
            env: "vp",
            output: "xml_vmap1",
            unviewed_position_start: 1,
            cust_params: {
              domain: "localhost" === window.location.hostname ? "localhost" : "sportsnet.ca"
            },
            cmsid: 624,
            vid: "".concat(y, "preroll"),
            correlator: new Date().valueOf(),
            url: window.location.hostname.href,
            vidwidth: 640,
            vidheight: 360
          }
        },
        disableCompanionAds: !1,
        vpaidMode: "enabled",
        disableFlashAds: !0
      },
      media: {
        title: y,
        src: m,
        medium: "audio",
        temporalType: "live",
        type: "application/x-mpegURL"
      },
      controls: {
        enabled: !1
      },
      plugins: {
        react: {
          enabled: !1
        }
      }
    };
    M.isDefined("amp-js") ? "undefined" != typeof window && ne(e) : (M.ready("amp-js", function () {
      "undefined" != typeof window && ne(e);
    }), M("https://www.sportsnet.ca/amp_2.123.14/amp.premier/amp.premier.min.js", "amp-js"));
  }, [m, p, f, h, y]);
  var ne = function () {
      var e,
        t = (e = i().mark(function e(t) {
          return i().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                re(), window.akamai.amp.AMP.create("#akamai-media-player", t, function (e) {
                  var t = e.player;
                  w.current = e.player, t.addEventListener("pause", function () {
                    return S(!1);
                  }), t.addEventListener("play", function () {
                    return S(!0);
                  }), t.addEventListener("playing", function () {
                    return L(!1);
                  }), t.addEventListener("waiting", function () {
                    return L(!0);
                  }), t.ads.addEventListener("started", function () {
                    return P(!0);
                  }), t.ads.addEventListener("skipped", function () {
                    return P(!1);
                  }), t.ads.addEventListener("ended", function () {
                    return P(!1);
                  }), t.ads.addEventListener("resume", function () {
                    return P(!0);
                  }), t.ads.addEventListener("pause", function () {
                    return P(!1);
                  });
                });
              case 2:
              case "end":
                return e.stop();
            }
          }, e);
        }), function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);
            function l(e) {
              a(i, r, o, l, c, "next", e);
            }
            function c(e) {
              a(i, r, o, l, c, "throw", e);
            }
            l(void 0);
          });
        });
      return function (e) {
        return t.apply(this, arguments);
      };
    }(),
    re = function re() {
      var e = w.current;
      e && (e.pause(), e.removeEventListener("pause", function () {
        return S(!1);
      }), e.removeEventListener("play", function () {
        return S(!0);
      }), e.removeEventListener("playing", function () {
        return L(!1);
      }), e.removeEventListener("waiting", function () {
        return L(!0);
      }), e.ads.removeEventListener("started", function () {
        return P(!0);
      }), e.ads.removeEventListener("skipped", function () {
        return P(!1);
      }), e.ads.removeEventListener("ended", function () {
        return P(!1);
      }), e.ads.removeEventListener("resume", function () {
        return P(!0);
      }), e.ads.removeEventListener("pause", function () {
        return P(!1);
      }));
    };
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: A,
    style: E && N ? {} : {
      display: "none"
    }
  }, e.createElement("div", {
    className: I
  }, e.createElement("div", {
    id: "akamai-media-player"
  }))), e.createElement("div", {
    className: "".concat(V, " ").concat(N ? F : D)
  }, e.createElement("div", {
    className: G
  }, e.createElement("img", {
    className: B,
    src: _,
    alt: "".concat(v, " logo")
  })), e.createElement("div", {
    className: q
  }, e.createElement("div", {
    className: z
  }, e.createElement("span", null, "ON-AIR:"), g && e.createElement("span", {
    className: J
  }, g), !g && e.createElement("span", {
    className: "".concat(J, " ").concat(Y)
  }, "Loading"), b && e.createElement("span", null, " ", "- ".concat(b)))), e.createElement("button", {
    className: U,
    onClick: function onClick() {
      "playing" === w.current.playState ? w.current.pause() : w.current.play();
    }
  }, O && e.createElement("div", {
    className: H
  }), R || E ? e.createElement("div", {
    className: X
  }) : e.createElement("img", {
    className: W
  })), u && e.createElement("button", {
    className: K,
    onClick: function onClick() {
      w.current.pause(), T(!1), d();
    }
  }, e.createElement("img", {
    src: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3e %3cpath id='Icon_material-close' data-name='Icon material-close' d='M19%2c6.41%2c17.59%2c5%2c12%2c10.59%2c6.41%2c5%2c5%2c6.41%2c10.59%2c12%2c5%2c17.59%2c6.41%2c19%2c12%2c13.41%2c17.59%2c19%2c19%2c17.59%2c13.41%2c12Z' transform='translate(-5 -5)' fill='%235bc2e7'/%3e%3c/svg%3e"
  })), e.createElement("button", {
    className: Z,
    onClick: function onClick() {
      Q ? (ee(!1), w.current.unmute()) : (ee(!0), w.current.mute());
    }
  }, e.createElement("img", {
    src: te
  }))));
};
Q.propTypes = {
  isMute: T.bool,
  hidePlayer: T.bool,
  dismissable: T.bool,
  onDismiss: T.func,
  enableAds: T.bool,
  autoplay: T.bool.isRequired,
  adpath: T.string.isRequired,
  callLetter: T.string.isRequired,
  streamUrl: T.string.isRequired,
  stationLogo: T.string.isRequired,
  stationName: T.string.isRequired,
  currentShowName: T.string,
  currentShowTime: T.string
}, Q.defaultProps = {
  isMute: !1,
  hidePlayer: !1,
  autoplay: !1,
  enableAds: !0
};
export { Q as RadioPlayer, Q as default };